var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("SearchableDocumentsList", {
        staticClass: "pb-5",
        attrs: {
          userFullName: _vm.managerFullName,
          query: _vm.query,
          currentUser: _vm.currentUser,
          extraInfoHidden: "",
          isCustomHeight: _vm.isCustomHeight,
        },
        on: { documentNumberChanged: _vm.handleDocumentNumberChanged },
        scopedSlots: _vm._u([
          {
            key: "emptyListActions",
            fn: function () {
              return [
                _c(
                  "p",
                  {
                    staticClass: "text-md text-primary-black text-center",
                    class: _vm.getBottom === "bottom-1.5" ? "my-16" : "my-20",
                    staticStyle: { width: "100%" },
                  },
                  [_vm._v("There are currently no documents.")]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "actions",
            fn: function ({ refetchDocuments }) {
              return [
                _c("UploadDocument", {
                  staticClass: "flex justify-end relative",
                  class: _vm.getBottom,
                  attrs: {
                    attachedToUserId: _vm.managerUserId,
                    companyId: _vm.companyId,
                    currentUserId: _vm.currentUser.id,
                    variant: "transparent",
                    currentUserParent: _vm.currentUser,
                  },
                  on: { documentAdded: refetchDocuments },
                }),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }